import { render, staticRenderFns } from "./post-purchase-button.vue?vue&type=template&id=69388f3d"
import script from "./post-purchase-button.vue?vue&type=script&lang=js"
export * from "./post-purchase-button.vue?vue&type=script&lang=js"
import style0 from "./post-purchase-button.vue?vue&type=style&index=0&id=69388f3d&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./post-purchase-button.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports